import React from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import logo from '../images/meegrow/white_logo.png'
const propTypes = {};

const defaultProps = {};

export default class Footer extends React.Component {
   constructor(props) {
      super(props);
      this.state = {};
   }

   render() {
      return (
         <footer className="footer theme-1">
                <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-lg-3">
                                <div className="logo">
                                    <a href="#">
                                        <img src={logo} alt="logo"/>
                                    </a>
                                </div>
                                <p>We Rely On Algorithms And Experience To Plan, Predict, Measure And Target Your Campaigns In Ways Never Thought Possible At A Typical Agency.</p>
                                {/* <div className="social-link social-white mt-15">
                                    
                                    <a href="#" className="ln"><i className="fa fa-linkedin"></i></a>
                                </div> */}
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <h5>Quick Links </h5>
                                <nav>
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        {/* <li>Products</li> */}
                                        {/* <ul style={{paddingLeft: "25px"}}>
                                            <li> <Link to="/product/tv-measure">TV Measurement</Link> </li>
                                            <li> <Link to="/product/media-market">Media Mix Simulator</Link> </li>
                                            <li>  <Link to="/product/tv-plan">TV Plan Optimizer</Link> </li>
                                            <li>  <Link to="/product/campaign-analysis">Campaign Analytics</Link> </li>
                                        </ul> */}
                                        {/* <li className="d-block d-md-none"><Link to="/career">Career</Link></li> */}
                                        {/* <li className="d-block d-md-none"><Link to="/about">About Us</Link></li> */}
                                        <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="col-md-6 col-lg-3 d-none d-md-block">
                                <h5>Our Products </h5>
                                <nav>
                                    <ul>
                                        {/* <li><Link to="/career">Career</Link></li> */}
                                        {/* <li><Link to="/about">About Us</Link></li> */}
                                        {/* <li><Link to="/contact">Contact Us</Link></li> */}
                                        <li> <Link to="/product/tv-measure">TV Measurement</Link> </li>
                                            <li> <Link to="/product/media-market">Media Mix Simulator</Link> </li>
                                            <li>  <Link to="/product/tv-plan">TV Plan Optimizer</Link> </li>
                                            <li>  <Link to="/product/campaign-analysis">Campaign Analytics</Link> </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className="copyright">
                                    <p>© Copyright 2019 | Designed and Developed by <a href="https://coimbatore.netart.io/"  target="_blank" rel="noopener noreferrer" ><span className="net">Net</span><span className="art">Art</span> </a></p>
                            </div>
                        </div>
                    </div>

        </footer>
      );
   }
}

 Footer.propTypes = propTypes;
 Footer.defaultProps = defaultProps;